'use client';

import React from 'react'
import Image from '@src/components/atoms/safe-image';

// Assets
import GroupC21Indonesia from '@public/png/group-c21-indonesia.png';

const DESCRIPTION = "Berdiri pada tahun 1971 oleh Art Bartlett dan Mash Fisher, keduanya adalah pengusaha dari Orange County, California. Mereka dihormati karena telah mengubah industri properti dan memajukan bisnis waralaba properti dunia menjadi lebih besar dan berpengaruh secara global. Banyak penghargaan yang diperoleh oleh CENTURY 21 telah memperkuat posisinya sebagai Merek Paling Dikenal dan Pemimpin Industri dalam hal Kesadaran Merek di bisnis Real Estate pada tingkat internasional."

const AboutCentury = () => {
  return (
    <div className='main-wrapper py-[104px] bg-black-1'>
      <div className='content-wrapper flex flex-col items-center justify-center'>
        <Image
          src={GroupC21Indonesia}
          alt='CENTURY 21'
          width="auto"
          height="auto"
          className='w-[500px] h-[56px] object-contain mb-[40px] 
          dd-lg:w-[285px] dd-lg:h-[32px]'
        />
        <div className='rounded-[24px] mb-[40px]'>
          <img
            src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/1.png"}
            alt="Art Bartlett and Mash Fisher"
            width="auto"
            height="auto"
            className='object-cover h-[540px] w-[960px] rounded-[24px] 
            dd-xl:w-full dd-xl:h-[365px] 
            dd-lg:h-[221px] 
            dd-md:h-[208px]'
          />
        </div>
        <p className='text-center text-17 text-white-3 w-full max-w-[760px] mb-[40px] 
        dd-lg:text-start'>{DESCRIPTION}</p>
      </div>
    </div>
  )
}

export default AboutCentury